'use strict';

module.exports = function mergeOptions(defaults, options) {
    options = options || Object.create(null);

    return [defaults, options].reduce(function (merged, optObj) {
        Object.keys(optObj).forEach(function (key) {
            merged[key] = optObj[key];
        });

        return merged;
    }, Object.create(null));
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/parse5/lib/utils/merge_options.js
 ** module id = 804
 ** module chunks = 0
 **/